import React from 'react';
import { logFrontendError } from './utils/logger'; // ✅ Correct path if ErrorBoundary.js is in src/

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    if (
      error?.message?.toLowerCase().includes('user rejected') ||
      error?.name === 'UserRejectedRequestError'
    ) {
      // Ignore wallet rejection errors
      return null;
    }
    return { hasError: true };
  }

  async componentDidCatch(error, errorInfo) {
    console.error('Caught by ErrorBoundary:', error, errorInfo);

    try {
      await logFrontendError(
        error.message,
        error.stack || errorInfo?.componentStack
      );
    } catch (e) {
      console.warn('Failed to log error to backend:', e);
    }
  }

  render() {
    return this.props.children;
  }
}

export default ErrorBoundary;
